// react_frontend/src/Components/Modules/PurchaseSetting/Today.js
import React, { useEffect, useState, useMemo } from "react";
import Breadcrumb from "../../Partials/Breadcrumb";
import DataTable from "react-data-table-component";
import { AxiosAuthInstance } from "../../../AxiosInterceptors";

// RSuite Components
import {
  Input,
  Badge,
  Loader,
  Message,
  toaster,
  DateRangePicker as RsuiteDateRangePicker,
  Button,
  Whisper,
  Tooltip,
} from "rsuite";
import "rsuite/dist/rsuite.min.css";

// Icons
import {
  FaHistory,
  FaCalendarAlt,
  FaBox,
  FaArrowUp,
  FaArrowDown,
  FaUser,
  FaSearch,
  FaSync,
} from "react-icons/fa";
import moment from "moment";

const TodayJs = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);

  const fetchData = async (range = null) => {
    setLoading(true);
    try {
      const payload = range ? { daterange: range } : {};
      const response = await AxiosAuthInstance.post("inventory/stock_today", payload);
      setData(response.data.transactions || []);
    } catch (error) {
      console.error("Failed to load today's stock:", error);
      toaster.push(
        <Message type="error" duration={5000}>
          Failed to load data.
        </Message>,
        { placement: "topEnd" }
      );
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDateRange = (range) => {
    if (!range) return;
    setDateRange(range);
    fetchData(range);
  };

  const filteredData = useMemo(() => {
    return data.filter((item) =>
      (item.item?.item_name || "").toLowerCase().includes(search.toLowerCase()) ||
      (item.stock_out_date || "").toLowerCase().includes(search.toLowerCase())
    );
  }, [data, search]);

  const columns = [
    {
      name: "SL",
      cell: (row, index) => <strong>{index + 1}</strong>,
      width: "100px",
      center: true,
    },
    {
      name: "Date",
      selector: (row) => row.stock_out_date,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div className="d-flex align-items-center gap-1">
          <FaCalendarAlt className="text-primary" />
          <small className="text-dark fw-medium">
            {moment(row.stock_out_date).format("MMM DD, YYYY")}
          </small>
        </div>
      ),
    },
    {
      name: "Item Name",
      selector: (row) => row.item?.item_name,
      sortable: true,
      grow: 2,
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          {row.stock_status === "return" ? (
            <FaArrowDown className="text-success" />
          ) : (
            <FaArrowUp className="text-danger" />
          )}
          <span className="fw-medium">{row.item?.item_name || "N/A"}</span>
        </div>
      ),
    },
    {
      name: "Quantity",
      selector: (row) =>
        row.stock_status === "return" ? row.return_goods : row.used_quantity,
      sortable: true,
      width: "140px",
      cell: (row) => {
        const qty =
          row.stock_status === "return" ? row.return_goods : row.used_quantity;
        return (
          <Badge
            color={row.stock_status === "return" ? "green" : "red"}
            content={`${qty} ${row.product_unit}`}
            style={{ fontSize: "0.85em" }}
          />
        );
      },
    },
    {
      name: "Type",
      width: "120px",
      cell: (row) => (
        <Badge
          color={row.stock_status === "return" ? "green" : "red"}
          content={row.stock_status === "return" ? "Return" : "Stock Out"}
          style={{ fontSize: "0.8em" }}
        />
      ),
      center: true,
    },
    // {
    //   name: "Created By",
    //   selector: (row) => row.creator?.name || row.creator_name,
    //   sortable: true,
    //   width: "160px",
    //   cell: (row) => {
    //     const name = row.creator?.name || row.creator_name || "Unknown";
    //     return (
    //       <div className="d-flex align-items-center gap-2">
    //         <FaUser className="text-primary" />
    //         <div className="fw-medium">{name}</div>
    //       </div>
    //     );
    //   },
    // },
    // {
    //   name: "Updated By",
    //   selector: (row) => row.updator?.name || row.updator_name,
    //   sortable: true,
    //   width: "160px",
    //   cell: (row) => {
    //     const name = row.updator?.name || row.updator_name || "—";
    //     return (
    //       <div className="d-flex align-items-center gap-2">
    //         <FaUser className="text-secondary" />
    //         <div className={name === "—" ? "text-muted" : "text-dark"}>
    //           {name}
    //         </div>
    //       </div>
    //     );
    //   },
    // },
    // {
    //   name: "Created At",
    //   selector: (row) => row.created_at,
    //   sortable: true,
    //   width: "180px",
    //   cell: (row) => (
    //     <div className="d-flex align-items-center gap-1">
    //       <FaCalendarAlt className="text-success" />
    //       <small>
    //         {moment(row.created_at).format("MMM DD, h:mm A")}
    //       </small>
    //     </div>
    //   ),
    // },
    // {
    //   name: "Updated At",
    //   selector: (row) => row.updated_at,
    //   sortable: true,
    //   width: "180px",
    //   cell: (row) => (
    //     <div className="d-flex align-items-center gap-1">
    //       <FaCalendarAlt className="text-warning" />
    //       <small>
    //         {row.updated_at === row.created_at ? (
    //           <span className="text-muted">—</span>
    //         ) : (
    //           moment(row.updated_at).format("MMM DD, h:mm A")
    //         )}
    //       </small>
    //     </div>
    //   ),
    // },
  ];

  const customStyles = {
    head: {
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        backgroundColor: "#f8f9fa",
      },
    },
    rows: {
      style: {
        fontSize: "14px",
        minHeight: "70px",
      },
    },
    cells: {
      style: {
        padding: "12px 8px",
      },
    },
  };

  return (
    <>
      <Breadcrumb title="Today's Stock Activity" />
      <div className="p-3 bg-white rounded shadow-sm mb-4 d-flex flex-wrap gap-3 align-items-center justify-content-between">
        <h5 className="text-dark mb-0">
          <FaHistory className="me-2" />
          Stock Usage & Returns
        </h5>
        <div className="d-flex gap-2 w-100 w-md-auto align-items-center">
          <Input
            placeholder="Search by item or date..."
            value={search}
            onChange={setSearch}
            prefix={<FaSearch />}
            style={{ width: 300 }}
            size="md"
          />
          <RsuiteDateRangePicker
            size="md"
            placeholder="Select Range"
            value={dateRange}
            onChange={handleDateRange}
            style={{ width: 260 }}
            title="Select date range for stock activity"
          />
          {/* Manual Refresh */}
          <Whisper placement="top" speaker={<Tooltip>Refresh data</Tooltip>}>
            <Button
              appearance="ghost"
              startIcon={<FaSync />}
              onClick={() => fetchData(dateRange)}
              size="md"
            >
              Refresh
            </Button>
          </Whisper>
        </div>
      </div>
      <DataTable
        keyField="id"
        columns={columns}
        data={filteredData}
        pagination
        paginationPerPage={100}
        paginationRowsPerPageOptions={[100, 250, 500, 1000]}
        progressPending={loading}
        progressComponent={
          <div className="d-flex justify-content-center my-5">
            <Loader size="md" /> <span className="ms-2">Loading today's data...</span>
          </div>
        }
        noDataComponent={
          <div className="text-center my-5 text-muted">
            <FaHistory size={48} className="mb-3 text-secondary" />
            <h5>No records found</h5>
            <p>Try adjusting your date range or check back later.</p>
          </div>
        }
        highlightOnHover
        responsive
        fixedHeader
        fixedHeaderScrollHeight="600px"
        customStyles={customStyles}
        striped
      />
    </>
  );
};

export default TodayJs;